import classNames from 'clsx'
import { bool, node, number, string } from 'prop-types'

import './BorderedText.scss'

const BorderedText = ({
  children,
  href,
  color,
  bgcolor,
  bordercolor,
  notexttransform,
  dataClientsideHook,
  dataQaId,
  smaller,
  skewed,
  skewedRight,
  bolder,
}) => {
  const Component = href ? 'a' : 'div'
  const classNameStem = href ? 'a-link' : 'u-color'
  const containerClassName = classNames('a-BorderedText a-h5 u-no-margin', {
    'a-link': href,
    'u-text--no-transform': notexttransform,
    [`${classNameStem}--${color}`]: color,
    [`u-background-color--${bgcolor}`]: bgcolor,
    [`u-border-color--${bordercolor} u-text--no-transform`]: bordercolor,
    'a-BorderedText--smaller': smaller,
    'a-BorderedText--skewed': skewed,
    'a-BorderedText--skewed-right': skewedRight,
    'u-font-weight--normal': !bolder,
    'a-BorderedText--bolder': bolder,
    'a-BorderedText--accent': color === 'blue' || color === 'positive',
  })
  const innerClassName = classNames('a-BorderedText--inner l-flex', {
    [`${classNameStem}--${color}`]: skewedRight && color,
    [`u-background-color--${bgcolor}`]: skewedRight && bgcolor,
    [`u-border-color--${bordercolor}`]: skewedRight && bordercolor,
    'a-BorderedText--inner--accent': color === 'blue' || color === 'positive',
  })

  const props = {
    className: containerClassName,
  }

  if (href) {
    props.href = href
  }

  if (dataClientsideHook) {
    props['data-clientside-hook'] = dataClientsideHook
  }

  return (
    <Component {...props}>
      <div className={innerClassName}>
        <span className="a-BorderedText__label u-no-wrap" data-qa-id={dataQaId}>
          {children}
        </span>
      </div>
    </Component>
  )
}

BorderedText.propTypes = {
  children: node.isRequired,
  href: string,
  color: string,
  bgcolor: string,
  bordercolor: string,
  notexttransform: bool,
  dataClientsideHook: string,
  dataQaId: number,
  smaller: bool,
  skewed: bool,
  skewedRight: bool,
  bolder: bool,
}

BorderedText.defaultProps = {
  href: null,
  color: null,
  bgcolor: null,
  bordercolor: null,
  notexttransform: null,
  dataClientsideHook: null,
  dataQaId: null,
  smaller: false,
  skewed: false,
  skewedRight: false,
  bolder: false,
}

export default BorderedText
